import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MustMatch } from '../../../../../src/_helpers/must-match.validator';
import { ApiSgsService } from '../api/api-sgs.service';



@Component({
  selector: 'app-sgsregister',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  
  constructor(
  private formBuilder: FormBuilder,
  private router: Router,
  public ApiSgsService: ApiSgsService
  ) { }
  showDetail = false;
  membertype = 0;
  ismembertypevalid = false;

  MyForm: FormGroup;
  submitted = false;
  loading = false;
  registersuccess=false;


  Action(){
    //this.showDetail = !this.showDetail;
     console.log('bisa dong');
  }

  ngOnInit() {

    
    this.MyForm = this.formBuilder.group({
            name: [{value:'',disabled:true}, Validators.required],
            sgsmembertype: ['', Validators.required],
            customerid: [''],
            pass: [{value:'',disabled:true}, [Validators.required,Validators.minLength(6)]],
            username: [{value:'',disabled:true}, Validators.required ],
            repass: [{value:'',disabled:true}, Validators.required ],
            email: [{value:'',disabled:true}, [Validators.required,Validators.email]],
            phonenumber: [{value:'',disabled:true}, [Validators.required,Validators.minLength(10),Validators.pattern('^[0-9]*$')]],
            description: ['']
        }, {
            validator: MustMatch('pass', 'repass')
        });

  }


get f() { return this.MyForm.controls; }

pickmembertype(i){
  //this.membertype = this.value;
  //alert();
  console.log(this.MyForm.value['sgsmembertype']);
  //console.log(this.f.sgsmembertype.setErrors({ return: _pr['username'] }));

}

onCustomerKey(e)
{
  console.log(e);
  this.byCustomer();
}

ismembertypevalidx(){
  console.log('x');
  this.MyForm.controls['fullname'].disable();

}

byCustomer()
{
  let custid = this.MyForm.value['customerid'];
  if ( custid == undefined || custid == ''){
    this.f.customerid.setErrors({ req: 'ID Pelanggan harus diisi' });
    return;
  }

  return this.ApiSgsService.searchCustomer({id:custid}).subscribe((output: any) => {
      console.log(output);   
      if (output.status == true){
        //this.registersuccess = true;
        this.ismembertypevalid = true;
        this.MyForm.controls['name'].enable();
        this.MyForm.controls['name'].setValue(output.data['nama']);
        this.MyForm.controls['pass'].enable();
        this.MyForm.controls['repass'].enable();
        this.MyForm.controls['username'].enable();
        this.MyForm.controls['email'].enable();
        this.MyForm.controls['phonenumber'].enable();


      }else{
        this.ismembertypevalid = false;
        this.MyForm.controls['name'].setValue('');
        this.MyForm.controls['name'].disable();

        this.MyForm.controls['pass'].setValue('');
        this.MyForm.controls['pass'].disable();

        this.MyForm.controls['repass'].setValue('');
        this.MyForm.controls['repass'].disable();

        this.MyForm.controls['username'].setValue('');
        this.MyForm.controls['username'].disable();
        this.MyForm.controls['email'].setValue('');
        this.MyForm.controls['email'].disable();
        this.MyForm.controls['phonenumber'].setValue('');
        this.MyForm.controls['phonenumber'].disable();
        this.f.customerid.setErrors({ return: 'ID Pelanggan tidak valid '});
        
      }                          
      //this.Prospectsgs = output.data;
    })
  //return false;
}


Submit()
{

  this.submitted = true;
  this.loading = true;
  // stop here if form is invalid
  if (this.MyForm.invalid) {
    
    return;
  }

  
  let data = this.MyForm.value;
  console.log(data);
  
  return this.ApiSgsService.postNewmember(data).subscribe((output: any) => {
      console.log(output);   
      if (output.status){
        this.registersuccess = true;
      }else{
        let _pr = JSON.parse(output.message);
        
        if (_pr['email']){
          this.MyForm.controls['email'].setErrors({ return: _pr['email'] });
        }
        if (_pr['username']){
          this.MyForm.controls['username'].setErrors({ return: _pr['username'] });
        }
      }                          
      //this.Prospectsgs = output.data;
    })
  //return false;
}



  submits()
  {

    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.MyForm.invalid) {
        this.loading = false;
        return;
    }

    let data = this.MyForm.value;
     console.log(data);

     /*
    return this.api.AddTeam(data).subscribe((output: {}) => {
      console.log(output);
      this.loading = false;
      this.router.navigate(['/admin/team']);
      
    }) */
  }
}
